/** Session notices survive navigation between the family screen and Home. */
export const FAMILY_NOTICE_EVENT = "family-notice";
let joined: string | null = null;
let deleted: string | null = null;
export function familyNotices() {
  return { joined, deleted };
}
export function announceFamilyJoin(name: string): void {
  deleted = null;
  joined = `You joined ${name}`;
  window.dispatchEvent(new Event(FAMILY_NOTICE_EVENT));
}
export function dismissFamilyJoin(): void {
  joined = null;
  window.dispatchEvent(new Event(FAMILY_NOTICE_EVENT));
}
export function announceFamilyDeletion(name: string): void {
  deleted = `${name} was deleted by its last member. Your own ledger isn't affected.`;
  window.dispatchEvent(new Event(FAMILY_NOTICE_EVENT));
}

export function dismissFamilyDeletion(): void {
  deleted = null;
  window.dispatchEvent(new Event(FAMILY_NOTICE_EVENT));
}
export function announceFamilyRemoval(name: string): void {
  deleted = `You're no longer in ${name}`;
  window.dispatchEvent(new Event(FAMILY_NOTICE_EVENT));
}
